module.exports = __webpack_public_path__ + "06eed0e0a7ab53d8b996e665db3907d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/SohoGothicPro/SohoGothicProRegular.ttf
// module id = 8042
// module chunks = 0